export function censorEmail(email: string | null | undefined): string {
  if (!email) return '';
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return email;
  const user = email.slice(0, atIndex);
  const domain = email.slice(atIndex + 1);
  const visible = user.slice(0, Math.min(2, user.length));
  return `${visible}***@${domain}`;
}
